import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["noClearFix"];
import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content-core/structured-content';
import baseStyles from '@nerdwallet/base-styles/react';
import Container from '@nerdwallet/react-container';
import { NativeType as Type } from '@nerdwallet/currency';
import { AnchorContextProvider } from './contexts/AnchorContext';
import { CitationContextProvider } from './contexts/CitationContext';
import { MarketplaceContextProvider } from './contexts/MarketplaceContext';
import { PrimitiveProvider } from './contexts/PrimitiveContext';

/**
 * StructuredContentWrapper Component
 * - default renders Primitives in <Type />
 * - wraps core StructuredContent in a clearfix Container unless noClearFix prop is set
 * - wraps core StructuredContent with AnchorContextProvider
 *   - this is to scope all AnchorLink/AnchorLinkTarget types to only this document by default
 *   - use <AnchorContextProvider> in your application to tie together AnchorLink/AnchorLinkTargets in multiple documents
 * - wraps core StructuredContent with MarketplaceContextProvider
 *   - this is to provide access to the marketplace context to grab loaded marketplace entities for OODMessage
 */
var StructuredContentWrapper = function StructuredContentWrapper(_ref) {
  var noClearFix = _ref.noClearFix,
      props = _objectWithoutProperties(_ref, _excluded);

  var children = /*#__PURE__*/React.createElement(AnchorContextProvider, null, /*#__PURE__*/React.createElement(CitationContextProvider, null, /*#__PURE__*/React.createElement(MarketplaceContextProvider, null, /*#__PURE__*/React.createElement(PrimitiveProvider, {
    Primitive: props.Primitive
  }, /*#__PURE__*/React.createElement(StructuredContent, props)))));
  if (noClearFix) return children;
  var containerProps = baseStyles('clearfix');
  return /*#__PURE__*/React.createElement(Container, containerProps, children);
};

StructuredContentWrapper.propTypes = _objectSpread(_objectSpread({}, StructuredContent.propTypes), {}, {
  noClearFix: PropTypes.bool
});
StructuredContentWrapper.defaultProps = _objectSpread(_objectSpread({}, StructuredContent.defaultProps), {}, {
  Primitive: Type,
  noClearFix: false
});
export default StructuredContentWrapper;